import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="hero-gradient pt-32 pb-20">
      <div className="section-container">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <motion.div 
            className="w-full md:w-1/2 text-center md:text-right"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 text-sharon-dark-green">
              שרון וייספלד
            </h1>
            <h2 className="text-2xl md:text-3xl font-medium mb-6 text-sharon-gray">
              פסיכולוגית מומחית - טיפול משפחתי, זוגי ואישי
            </h2>
            <p className="text-lg mb-8 text-sharon-gray max-w-lg mx-auto md:mr-0">
              מעניקה טיפול מקצועי ואמפתי לאנשים המחפשים דרכים להתמודד עם האתגרים שהחיים מזמנים להם
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start space-y-4 sm:space-y-0 sm:space-x-4 sm:space-x-reverse">
              <Link to="/about" className="sharon-btn text-lg px-6 py-2 rounded-md">
                קרא עוד
              </Link>
              <a 
                href="tel:+972526507776" 
                className="text-sharon-dark-green hover:text-sharon-green transition-colors duration-300 text-lg"
              >
                צור קשר: 0526507776
              </a>
            </div>
          </motion.div>

          <motion.div 
            className="w-full md:w-1/2 mt-12 md:mt-0 flex justify-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            <div className="w-64 h-64 md:w-80 md:h-80 rounded-full bg-sharon-light-green overflow-hidden border-4 border-white shadow-lg">
              <img 
                src="https://i.imgur.com/3TOThL8.png" 
                alt="שרון וייספלד" 
                className="w-full h-full object-cover"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;